var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseModal',{attrs:{"modalHeader":_vm.$t('terms_and_condition'),"modalId":"modal-tac"}},[_c('div',{attrs:{"slot":"modal-body"},domProps:{"innerHTML":_vm._s(_vm.getContent)},slot:"modal-body"})])}
var staticRenderFns = []

export { render, staticRenderFns }